import { render, staticRenderFns } from "./EditAjustesOrigen.vue?vue&type=template&id=122e4a68"
import script from "./EditAjustesOrigen.vue?vue&type=script&lang=js"
export * from "./EditAjustesOrigen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports